export default __webpack_public_path__ + "static/media/jsbin.8d17a572.svg";